
import React from 'react'
import { IconButton, Tooltip } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'

const OperacionAdelantoDeCupos = (props) => {
  return (
    <Tooltip title={'Eliminar'}>
      <IconButton onClick={props.handleDelete}>
        <DeleteIcon />
      </IconButton>
    </Tooltip>
  )
}

export default OperacionAdelantoDeCupos
